import React, { useState } from 'react';
import '../components/css/CatForum.css';

const CatForum = () => {
  const forumData = {
    stats: {
      topics: 4287,
      posts: 29354,
      users: 12876,
      newestUser: "猫咪爱好者",
      onlineUsers: 243
    },
    categories: [
      { id: 1, name: "猫咪健康", description: "讨论猫咪健康、疾病预防和治疗相关话题", topics: 1243, posts: 8976, icon: "bi bi-heart-pulse" },
      { id: 2, name: "猫咪行为", description: "分享和了解猫咪行为习惯、训练技巧和沟通方式", topics: 987, posts: 7654, icon: "bi bi-emoji-smile" },
      { id: 3, name: "猫咪饮食", description: "交流猫咪饮食、营养需求和食谱分享", topics: 756, posts: 5432, icon: "bi bi-cup-hot" },
      { id: 4, name: "猫咪品种", description: "探讨不同猫咪品种的特点、性格和护理需求", topics: 543, posts: 3210, icon: "bi bi-award" },
      { id: 5, name: "新手养猫", description: "为初次养猫的铲屎官提供建议和指导", topics: 432, posts: 2109, icon: "bi bi-stars" },
      { id: 6, name: "猫咪摄影", description: "分享你的猫咪照片和摄影技巧", topics: 321, posts: 1876, icon: "bi bi-camera" },
      { id: 7, name: "颜值PK", description: "展示和比较猫咪的外貌、颜值，进行投票和评选", topics: 289, posts: 1654, icon: "bi bi-trophy" }
    ],
    recentTopics: [
      { id: 1, title: "我家猫咪最近不爱吃饭，该怎么办？", author: "猫咪爱好者", category: "猫咪健康", replies: 23, views: 156, lastReply: "2025-04-27", isHot: true, avatar: "https://i.pravatar.cc/150?img=1" },
      { id: 2, title: "布偶猫和英短蓝猫哪个更适合家庭饲养？", author: "猫爸爸", category: "猫咪品种", replies: 45, views: 278, lastReply: "2025-04-26", isHot: true, avatar: "https://i.pravatar.cc/150?img=2" },
      { id: 3, title: "分享一些我家猫咪的有趣行为", author: "猫咪摄影师", category: "猫咪行为", replies: 19, views: 132, lastReply: "2025-04-25", isHot: false, avatar: "https://i.pravatar.cc/150?img=3" },
      { id: 4, title: "自制猫粮食谱分享", author: "鱼猫共处", category: "猫咪饮食", replies: 34, views: 201, lastReply: "2025-04-24", isHot: false, avatar: "https://i.pravatar.cc/150?img=4" },
      { id: 5, title: "新手养猫需要准备哪些物品？", author: "北方猫主", category: "新手养猫", replies: 56, views: 345, lastReply: "2025-04-23", isHot: true, avatar: "https://i.pravatar.cc/150?img=5" },
      { id: 6, title: "五月颜值PK大赛开始啦，快来投票选出最美猫咪！", author: "猫咪评委", category: "颜值PK", replies: 67, views: 412, lastReply: "2025-04-29", isHot: true, avatar: "https://i.pravatar.cc/150?img=6" }
    ],
    popularTopics: [
      { id: 1, title: "猫咪绝育的最佳时间", replies: 78, views: 523 },
      { id: 2, title: "如何训练猫咪使用猫砂盆", replies: 65, views: 489 },
      { id: 3, title: "猫咪常见疾病预防指南", replies: 54, views: 412 },
      { id: 4, title: "不同品牌猫粮对比评测", replies: 47, views: 376 },
      { id: 5, title: "如何让猫咪和狗狗和平相处", replies: 39, views: 321 },
      { id: 6, title: "如何拍出猫咪最美的一面", replies: 82, views: 567 }
    ],
    activeUsers: [
      { id: 1, name: "猫咪爱好者", posts: 156, avatar: "https://i.pravatar.cc/150?img=1" },
      { id: 2, name: "猫爸爸", posts: 132, avatar: "https://i.pravatar.cc/150?img=2" },
      { id: 3, name: "猫咪摄影师", posts: 98, avatar: "https://i.pravatar.cc/150?img=3" },
      { id: 4, name: "鱼猫共处", posts: 87, avatar: "https://i.pravatar.cc/150?img=4" },
      { id: 5, name: "北方猫主", posts: 76, avatar: "https://i.pravatar.cc/150?img=5" }
    ]
  };

  const { stats, categories, recentTopics, popularTopics, activeUsers } = forumData;

  return (
    <div className="container py-4 compact-layout">
      {/* Forum Stats */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="row text-center">
                {[
                  { value: stats.topics.toLocaleString(), label: "主题" },
                  { value: stats.posts.toLocaleString(), label: "帖子" },
                  { value: stats.users.toLocaleString(), label: "用户" },
                  { value: stats.newestUser, label: "最新用户" }
                ].map((item, idx) => (
                  <div key={idx} className={`col-md-3 col-6 ${idx < 2 ? 'mb-2 mb-md-0' : ''}`}>
                    <h3 className="fw-bold text-primary">{item.value}</h3>
                    <p className="text-muted mb-0">{item.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        {/* Main Content */}
        <div className="col-lg-8">
          {/* Categories */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-header bg-white py-2">
              <h5 className="mb-0 fw-bold">论坛分类</h5>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th scope="col">分类</th>
                      <th scope="col" className="text-center">主题</th>
                      <th scope="col" className="text-center">帖子</th>
                      <th scope="col" className="d-none d-md-table-cell">最新帖子</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map(cat => (
                      <tr key={cat.id}>
                        <td>
                          <div className="d-flex align-items-center">
                            <i className={`${cat.icon} fs-4 text-primary me-2`}></i>
                            <div>
                              <h6 className="mb-0 fw-bold">{cat.name}</h6>
                              <p className="mb-0 text-muted small">{cat.description}</p>
                            </div>
                          </div>
                        </td>
                        <td className="text-center">{cat.topics}</td>
                        <td className="text-center">{cat.posts}</td>
                        <td className="d-none d-md-table-cell">
                          <small className="text-muted">由 <span className="fw-bold">猫咪爱好者</span> 发布于 2025-04-28</small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Recent Topics */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-header bg-white py-2 d-flex justify-content-between align-items-center">
              <h5 className="mb-0 fw-bold">最新主题</h5>
              <div className="dropdown">
                <button className="btn btn-sm btn-outline-secondary dropdown-toggle py-0 px-2" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">排序方式</button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li><a className="dropdown-item" href="#">最新发布</a></li>
                  <li><a className="dropdown-item" href="#">最多回复</a></li>
                  <li><a className="dropdown-item" href="#">最多浏览</a></li>
                </ul>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th scope="col">主题</th>
                      <th scope="col" className="text-center d-none d-md-table-cell">回复</th>
                      <th scope="col" className="text-center d-none d-md-table-cell">浏览</th>
                      <th scope="col">最后回复</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentTopics.map(topic => (
                      <tr key={topic.id}>
                        <td>
                          <div className="d-flex align-items-center">
                            <img src={topic.avatar} alt={topic.author} className="rounded-circle me-2 avatar-sm" width="32" height="32" />
                            <div>
                              <div className="d-flex align-items-center">
                                <h6 className="mb-0 fw-bold">{topic.title}</h6>
                                {topic.isHot && <span className="badge bg-danger ms-1">热门</span>}
                              </div>
                              <p className="mb-0 text-muted small">由 <span className="fw-bold">{topic.author}</span> 发布在 <span className="text-primary">{topic.category}</span></p>
                            </div>
                          </div>
                        </td>
                        <td className="text-center d-none d-md-table-cell">{topic.replies}</td>
                        <td className="text-center d-none d-md-table-cell">{topic.views}</td>
                        <td><small className="text-muted">{topic.lastReply}</small></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer bg-white text-center py-2">
              <button className="btn btn-sm btn-outline-primary">查看更多主题</button>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="col-lg-4">
          {/* Search */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-body">
              <h5 className="card-title fw-bold mb-2">搜索论坛</h5>
              <div className="input-group">
                <input type="text" className="form-control form-control-sm" placeholder="输入关键词..." />
                <button className="btn btn-primary btn-sm" type="button"><i className="bi bi-search"></i></button>
              </div>
            </div>
          </div>

          {/* Popular Topics */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-header bg-white py-2">
              <h5 className="mb-0 fw-bold">热门主题</h5>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                {popularTopics.map(topic => (
                  <li key={topic.id} className="list-group-item px-0 py-2 border-bottom">
                    <h6 className="mb-0 fw-bold">{topic.title}</h6>
                    <div className="d-flex text-muted small">
                      <span className="me-2"><i className="bi bi-chat-dots me-1"></i> {topic.replies} 回复</span>
                      <span><i className="bi bi-eye me-1"></i> {topic.views} 浏览</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Active Users */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-header bg-white py-2">
              <h5 className="mb-0 fw-bold">活跃用户</h5>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                {activeUsers.map(user => (
                  <li key={user.id} className="list-group-item px-0 py-1 border-bottom">
                    <div className="d-flex align-items-center">
                      <img src={user.avatar} alt={user.name} className="rounded-circle me-2 avatar-sm" width="32" height="32" />
                      <div>
                        <h6 className="mb-0 fw-bold">{user.name}</h6>
                        <small className="text-muted">{user.posts} 帖子</small>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Forum Stats Card */}
          <div className="card border-0 shadow-sm mb-3 bg-light">
            <div className="card-body">
              <h5 className="card-title fw-bold mb-2">论坛信息</h5>
              <ul className="list-group list-group-flush">
                {[
                  { label: "总主题数", value: stats.topics },
                  { label: "总帖子数", value: stats.posts },
                  { label: "注册用户", value: stats.users },
                  { label: "在线用户", value: stats.onlineUsers }
                ].map((item, idx) => (
                  <li key={idx} className={`list-group-item bg-transparent px-0 py-1 ${idx < 3 ? 'border-bottom' : ''}`}>
                    <div className="d-flex justify-content-between">
                      <span>{item.label}</span>
                      <span className="fw-bold">{item.value.toLocaleString()}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CatForum;
